import { BaseEntity } from "@app/models/rest/base-entity";
import {
  HateoasProjection,
  HateoasResource
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("zones")
export class Zone extends BaseEntity {
  area: string;
  name: string;
  ordinal: number;
  backgroundColor: string;
  foregroundColor: string;
}

@HateoasProjection(Zone, "detail")
export class ZoneBasicProjection extends BaseEntity {
  name: string;
}
